import { createSelector } from 'reselect'
import { fromJS } from 'immutable'

const getOfferings = (state) => state.offeringState
const getEnrolled = (state) => state.enrolledState

// filter offerings by is_checked
export const makeGetSelected = () => createSelector(
  [getOfferings],
  (offerings) => {
    let response = fromJS([])
    offerings.map((offering, k) => {
      if (offering.get('is_checked')) {
        response = response.push(offering.set('k', k))
      }
      return true
    })
    return response
  }
)

// filter offerings,
// remove enrolled
export const makeGetFilteredOfferings = () => createSelector(
  [getOfferings, getEnrolled],
  (offerings, enrolled) => {
    let response = fromJS([])
    for (let i = 0, l = offerings.size; i < l; i++) {
      let found = false
      for (let j = 0, l2 = enrolled.size; j < l2; j++) {
        if (offerings.getIn([i, 'id']) === enrolled.getIn([j, 'offering_subject_id'])) {
          found = true
          break
        }
      }
      if (!found) {
        response = response.push(offerings.get(i).set('k', i))
      }
    }

    return response
  }
)



// WEBPACK FOOTER //
// ./src/containers/Enrolment/selectors.js